"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugGUI = void 0;
const gui_base_1 = require("./gui_base");
class DebugGUI extends gui_base_1.GUIBase {
    constructor(debug) {
        super();
        this.debug = debug;
        this.gui = gui_base_1.GUIBase.createFolder('Debug');
        this.gui.add(this.debug, 'fps').name('FPS Counter');
        this.gui.add(this.debug, 'trackables').name('Tracking Data');
        this.gui.add(this.debug, 'allowFaceToFaceMode').name('Allow Face To Face Mode');
    }
}
exports.DebugGUI = DebugGUI;
//# sourceMappingURL=gui_debug.js.map